import { AssociationBuilder } from './associations';

/**
 * SubscriptionsAdmin
 */

/**
 * BillingWizard
 */

// scraped out of GQL allAssociationTypesFromObjectType(objectType: "0-69")
// and the backend "DefaultAssociationType"
// then manually trimmed to only include the ones we will use
export const DefaultAssociation = Object.freeze({
  SUBSCRIPTION_TO_TICKET: 'SUBSCRIPTION_TO_TICKET',
  SUBSCRIPTION_TO_CONTRACT: 'SUBSCRIPTION_TO_CONTRACT',
  SUBSCRIPTION_TO_PAYMENT_LINK: 'SUBSCRIPTION_TO_PAYMENT_LINK',
  SUBSCRIPTION_TO_COMMERCE_PAYMENT: 'SUBSCRIPTION_TO_COMMERCE_PAYMENT',
  SUBSCRIPTION_TO_INVOICE: 'SUBSCRIPTION_TO_INVOICE',
  SUBSCRIPTION_TO_QUOTE: 'SUBSCRIPTION_TO_QUOTE',
  SUBSCRIPTION_TO_CONTACT: 'SUBSCRIPTION_TO_CONTACT',
  SUBSCRIPTION_TO_COMPANY: 'SUBSCRIPTION_TO_COMPANY',
  SUBSCRIPTION_TO_DEAL: 'SUBSCRIPTION_TO_DEAL'
});

/** some associations are 1:1 on the subscription side, so we represent them with a tuple
 * https://tools.hubteam.com/lighthouse/associations?fromObjectTypeId=0-69&toObjectTypeId=0-721 */

export function getDefaultAssociations() {
  return new AssociationBuilder().build();
}

/** The object we're converting from to create a subscription */